// src/config/api.js
export const API_BASE_URL =
  process.env.REACT_APP_PSYASSIST_API_URL ||
  "https://api.psyassist.com.br";
